function getCountdownSettings() {
  const marquee = document.querySelector("marquee-component");

  if (!marquee) return null;

  const start = marquee.dataset.countdownStart;
  const hours = parseInt(marquee.dataset.countdownHours || "24", 10);

  if (!start) return null;

  return {
    end: new Date(start).getTime() + hours * 60 * 60 * 1000
  };
}

function updateCountdown() {
  const settings = getCountdownSettings();

  if (!settings) return;

  const diff = settings.end - Date.now();

  document.querySelectorAll(".text-block").forEach((el) => {
    if (el.textContent.trim() !== "COUNTDOWN_PLACEHOLDER") return;

    if (diff <= 0) {
      el.textContent = "00:00:00";
      return;
    }

    const totalSeconds = Math.floor(diff / 1000);

    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;

    el.textContent =
      `${String(h).padStart(2, "0")}:` +
      `${String(m).padStart(2, "0")}:` +
      `${String(s).padStart(2, "0")}`;
  });
}

updateCountdown();
setInterval(updateCountdown, 1000);